/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2024-05-15 15:00:00
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import { Card, Heading, Link } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import StarIcon from 'src/assets/images/subscription-v4/star-review.svg';
import { Carousel } from 'src/components/views/common/carousel';
import { URL } from 'src/constants/links';
import { GOOD_REVIEWS } from 'src/constants/subscription';

type Props = {
  active: boolean,
  handleChangeModal: Function
};

type ComposedProps = Props & WithI18nProps;

class ReviewBlock extends Component<ComposedProps> {
  state = {
    isScrollToBottom: false
  };

  render() {
    const { i18n } = this.props;

    const itemsElement = GOOD_REVIEWS.map(i => {
      return (
        <div>
          <div className="head">
            <div className="name">{i.name}</div>
            <div className="stars">
              <img alt="star" src={StarIcon} />
              <img alt="star" src={StarIcon} />
              <img alt="star" src={StarIcon} />
              <img alt="star" src={StarIcon} />
              <img alt="star" src={StarIcon} />
            </div>
          </div>
          <div className="date">{i.date}</div>
          <div className="content">{i.content}</div>
        </div>
      );
    });
    return (
      <div className="ReviewBlock">
        <Card>
          <div className="header">
            <Heading>{i18n.translate(`AdminHTML.SubscriptionV4.Banner.Review.title`)}</Heading>
            <Link external url={URL['BoostAppReview']}>
              {i18n.translate(`AdminHTML.SubscriptionV4.Banner.Review.link`)}
            </Link>
          </div>
          <div className="slide">
            <Carousel
              autoHeight={true}
              // alwaysShowSlide={true}
              items={itemsElement}></Carousel>
          </div>
        </Card>
      </div>
    );
  }

  handleChange = () => {
    this.props.handleChangeModal();
  };

  handleScroll = () => {
    this.setState({ isScrollToBottom: true });
  };

  handleSubscribe = () => {
    this.props.handleChangeModal();
    this.props.subscribe();
  };
}

export default withI18n()(ReviewBlock);
